module.exports = __webpack_public_path__ + "static/media/downloadGCSPopup.085a74df.svg";